/* MOZINA — kleine, afhankelijkheidsvrije helpers voor de eigen secties. */
(function () {
  'use strict';

  /* ---- Countdown ---------------------------------------------------------
     <mz-countdown data-until="2026-09-01T23:59:59" data-hide-when-done="true">
       <span data-d></span><span data-h></span><span data-m></span><span data-s></span>
     </mz-countdown>                                                          */
  class MzCountdown extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.until;
      this.target = raw ? new Date(raw).getTime() : NaN;
      if (isNaN(this.target)) return;
      this.slots = {
        d: this.querySelector('[data-d]'),
        h: this.querySelector('[data-h]'),
        m: this.querySelector('[data-m]'),
        s: this.querySelector('[data-s]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      let diff = this.target - Date.now();
      if (diff <= 0) {
        clearInterval(this.timer);
        if (this.dataset.hideWhenDone === 'true') {
          const bar = this.closest('[data-mz-promo]') || this;
          bar.style.display = 'none';
        }
        diff = 0;
      }
      const s = Math.floor(diff / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      if (this.slots.d) this.slots.d.textContent = pad(Math.floor(s / 86400));
      if (this.slots.h) this.slots.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (this.slots.m) this.slots.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (this.slots.s) this.slots.s.textContent = pad(s % 60);
    }
  }
  if (!customElements.get('mz-countdown')) customElements.define('mz-countdown', MzCountdown);

  /* ---- Rail-navigatie (pijltjes links/rechts) ---------------------------- */
  class MzRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.track) return;
      const step = () => Math.max(240, Math.round(this.track.clientWidth * 0.8));
      this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.sync();
    }
    sync() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
      this.prev.style.opacity = this.prev.disabled ? '.35' : '1';
      this.next.style.opacity = this.next.disabled ? '.35' : '1';
    }
  }
  if (!customElements.get('mz-rail')) customElements.define('mz-rail', MzRail);

  /* ---- Reveal on scroll --------------------------------------------------- */
  const reveal = () => {
    const items = document.querySelectorAll('.mz-reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach((el) => io.observe(el));
  };
  document.addEventListener('DOMContentLoaded', reveal);
  document.addEventListener('shopify:section:load', reveal);
})();
